import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import AlertContext from "../../../../context/Alert/AlertContext";
import axiosPrivate from "../../../../hooks/axiosPrivate";
import PermissionTableTd from "./PermissionTableTd";
import LoaderContext from "../../../../context/Loader/LoaderContext";
var formData = new FormData();

const validationRules = {};

const UserPermission = () => {
  let { userId, roleId } = useParams();
  const { setAlertMessage } = useContext(AlertContext);
  const { setLoaderCheck } = useContext(LoaderContext);
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState([]);
  const [userPermissions, setUserPermissions] = useState([]);
  const [permissionDistinctName, setPermissionDistinctName] = useState([]);
  const [userPermissionsId, setUserPermissionsId] = useState([]);



  

  useEffect(() => {
    setLoaderCheck(true);
    axiosPrivate
      .get("permissions")
      .then((fetched_permissions) => {
        setLoaderCheck(false);
        setPermissions(fetched_permissions?.data?.data);
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
    setLoaderCheck(true);
    axiosPrivate
      .get("permissions/distinct/name")
      .then((distinctName) => {
        setLoaderCheck(false);
        setPermissionDistinctName(distinctName?.data?.data);
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
  }, []);

  useEffect(() => {
    setLoaderCheck(true);
    axiosPrivate
      .get(`user-has-permissions/user/${userId}`)
      .then((fetched_user_permissions) => {

        setLoaderCheck(false);
        setUserPermissions(fetched_user_permissions?.data?.data);

        if (fetched_user_permissions.data.data.length) {
          let userPermissionsArray = [];

          for (let m = 0; m < fetched_user_permissions.data.data.length; m++) {
            userPermissionsArray.push(
              fetched_user_permissions.data.data[m].id
            );
          }
          setUserPermissionsId(userPermissionsArray);
        }
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
  }, [userId]);

  useEffect(() => {
    setLoaderCheck(true);
    axiosPrivate
      .get("permissions")
      .then((fetched_permissions) => {
        setLoaderCheck(false);
        setPermissions(fetched_permissions?.data?.data);
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
    setLoaderCheck(true);
    axiosPrivate
      .get("permissions/distinct/name")
      .then((distinctName) => {
        setLoaderCheck(false);
        setPermissionDistinctName(distinctName?.data?.data);
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          //response status is an error code
          console.log(error.response.status);
        } else if (error.request) {
          //response not received though the request was sent
          console.log(error.request);
        } else {
          //an error occurred when setting up the request
          console.log(error.message);
        }
      });
  }, [userPermissionsId]);

  
  
  const modifyPermissionIdArray = async (permission_id, action) => {
    if (action === false) {
      const index = userPermissionsId.indexOf(permission_id);
      userPermissionsId.splice(index, 1);
    } else {
      userPermissionsId.push(permission_id);
    }
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    let values = {
      user_id: userId,
      role_id: roleId,
      permission_ids: userPermissionsId,
    };
    setLoaderCheck(true);
    await axiosPrivate
      .post(`user-has-permissions`, values)
      .then((response) => {
        setLoaderCheck(false);
        setAlertMessage({ message: "User Permission added successfully" });
        navigate("/admin/users");
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          if (error.response.status !== 201) {
          }
        }
      });
  };

  const title = ["Create", "Edit", "View", "Delete"];
  const rows = permissionDistinctName.map((distinct, index) => {
    return (
      <tr key={index}>
        <td>{distinct.name}</td>
        {permissions.map((permission, index1) => {
          const checked = userPermissionsId.includes(String(permission?.id));
          
          if (permission.name === distinct.name) {
            if (permission.action === "create") {
                return (
                  <PermissionTableTd
                    tdKey={index1}
                    key={index1}
                    id={permission.id}
                    checked={checked}
                    modifyPermissionIdArray={modifyPermissionIdArray}
                  />
                );
              }
            if (permission.action === "update") {
              return (
                <PermissionTableTd
                  tdKey={index1}
                  key={index1}
                  id={permission.id}
                  checked={checked}
                  modifyPermissionIdArray={modifyPermissionIdArray}
                />
              );
            }
            if (permission.action === "read") {
              return (
                <PermissionTableTd
                  tdKey={index1}
                  key={index1}
                  id={permission.id}
                  checked={checked}
                  modifyPermissionIdArray={modifyPermissionIdArray}
                />
              );
            }
            if (permission.action ===  "delete") {
              return (
                <PermissionTableTd
                  tdKey={index1}
                  key={index1}
                  id={permission.id}
                  checked={checked}
                  modifyPermissionIdArray={modifyPermissionIdArray}
                />
              );
            }
          }
        })}
      </tr>
    );
  });

  return (
    <div className="section-body mt-3">
      <div className="container-fluid">
        <div className="tab-content mt-3">
          <form onSubmit={submitHandler}>
            <div
              className="tab-pane fade show active"
              id="user-permissions"
              role="tabpanel"
            >
              <div className="card">
                <div className="card-header">
                  <strong>User Permissions</strong>
                </div>
                <div className="card-body">
                  <div className="row clearfix">
                    <div className="col-12">
                      <div className="table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th />
                              {title.map((name, key) => (
                                <th key={key}>{name}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>{rows}</tbody>
                        </table>
                      </div>
                      <button
                        type="button"
                        id="button_1"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={() => navigate("/admin/users")}
                      >
                        CLOSE
                      </button>
                      <button
                        type="submit"
                        id="button_2"
                        className="btn btn-primary float-right"
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default UserPermission;
